import { gql } from "@apollo/client";

export const getTreeByPath = gql`
  query GetTreeByPath($path: String!) {
    pages {
      treeByPath(locale: "pt-br", path: $path) {
        id
        path
        title
        depth
      }
    }
  }
`;
